<template>
  <div class="order-page-section">
    <div v-if="isPanel" class="order-page-panel"><slot /></div>
    <slot v-else />
  </div>
</template>

<script>
export default {
  props: {
    isPanel: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.order-page-section {
  box-sizing: border-box;
  width: 100%;
  padding: 0 20/20rem;

  .order-page-panel {
    box-sizing: border-box;
    width: 100%;
    height: auto;
    margin-top: 20/20rem;
    padding: 1/20rem 16/20rem;
    background-color: #f7f7f7;
  }
}
</style>
